import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ImageLightbox = ({ image, alt, onClose }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e?.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[1100] bg-background/95 flex items-center justify-center p-4 md:p-6 lg:p-8"
      onClick={onClose}
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 md:top-6 md:right-6 w-10 h-10 md:w-12 md:h-12 rounded-lg bg-card border border-border flex items-center justify-center transition-all duration-250 hover:bg-muted hover:scale-105"
        aria-label="Close lightbox"
      >
        <Icon name="X" size={24} color="var(--color-foreground)" />
      </button>
      <div
        className="max-w-6xl w-full max-h-[90vh] overflow-hidden rounded-lg"
        onClick={(e) => e?.stopPropagation()}
      >
        <Image
          src={image}
          alt={alt}
          className="w-full h-full object-contain"
        />
      </div>
    </div>
  );
};

export default ImageLightbox;